import React, { Component } from 'react';
import { DefaultButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { DetailsList, Selection } from 'office-ui-fabric-react/lib/DetailsList';
import { Panel, PanelType } from 'office-ui-fabric-react';
import { MessageBars } from '../Outils/MessageBars';

import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';

import Scriba from 'react-scriba';
import { Immocom } from '../../specifique/immocom';

import { DataDocumentReservation } from '../../data/DataDocumentReservation.jsx';

/****************************************************************
 PROPS:
    idOperation
    idReservation
    onAffichePanelDocumentReservation
    onFermeFicheDocumentReservation
    classnameinner : classe CSS (string)
    className : classe CSS (string)
****************************************************************/

var objetState = {
    idOperation: 0,
    idReservation: 0,
    documents: [],
    listDocumentsSelectionnes: [],
    enCoursDeTraitement: false,
    messageEnCoursTraitement: '',
    hideMessageBarError: true,
    errorMessage: '',
    hideMessageBarWarning: true,
    warningMessage: '',
};

export class FicheDocumentReservation extends Component {
    _creationContent() {
        return (
            <Panel
                isOpen={this.props.onAffichePanelDocumentReservation}
                type={PanelType.extraLarge}
                onDismiss={() => this._onAnnulation()}
                onOpen={() => this._onOpen()}
                headerText='Ajouter un document'
                closeButtonAriaLabel="Fermer"
                onRenderFooterContent={this._onRenderFooterContent}
            >
                <div className={this.props.className}>
                    <div className={this.props.classnameinner}>
                        <div className="ms-Grid" dir="ltr">
                            <MessageBars
                                errorMessage={this.state.errorMessage}
                                warningMessage={this.state.warningMessage}
                                onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                                onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                            />

                            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

                            <DetailsList
                                items={this.state.documents}
                                columns={this.columns}
                                selection={this._selection}
                            />
                        </div>
                    </div>
                </div>
            </Panel>
        );
    }

    constructor(props) {
        super(props);

        this._selection = new Selection({
            onSelectionChanged: () => {
                this.setState({ detailsSelectionDocuments: this._getDetailsSelectionDocuments() });
            }
        });

        this.state = objetState;

        this.columns = [
            {
                key: 'nomDocument', name: 'Document', fieldName: 'nomDocument', minWidth: 300, maxWidth: 600, isResizable: true,
                onRender: (item) => {
                    let nomDocument = item.nom;

                    return <span title={nomDocument}>{nomDocument}</span>;
                }
            },
            {
                key: 'categorie', name: 'Catégorie', fieldName: 'categorie', minWidth: 100, maxWidth: 200, isResizable: true,
            },
            {
                key: 'typeDocument', name: 'Type', fieldName: 'typeDocument', minWidth: 100, maxWidth: 200, isResizable: true,
            }
        ];
    }

    _onInit() {
        this.setState(objetState);
    }

    _onAnnulation = () => {
        this._onInit();
        this.props.onFermeFicheDocumentReservation();
    }

    _getDetailsSelectionDocuments() {
        const selectionCount = this._selection.getSelectedCount();

        switch (selectionCount) {
            case 0:
                return '';
            case 1:
                return '1 document sélectionné : ' + (this._selection.getSelection()[0]).nom;
            default:
                return `${selectionCount} documents sélectionnés`;
        }
    }

    //_validationFormulaire(item) {
    //    let estValide = true;

    //    // Si l'objet n'est pas vide
    //    if (!(Object.keys(item).length === 0 && item.constructor === Object)) {
    //        if (Scriba.formulaire().nEstPasVide(item.destinataire)) {
    //            estValide = estValide && (this._selection.getSelectedCount() > 0);
    //        }
    //        else {
    //            estValide = false;
    //        }
    //    }
    //    else {
    //        estValide = false;
    //    }

    //    return estValide;
    //}

    _onEnregistrement() {
        let idReservation = this.props.idReservation;
        let idOperation = this.props.idOperation;

        if (idReservation > 0 && idOperation > 0) {
            this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: "Enregistrement des documents" });

            var enregistrementDocumentReservation = DataDocumentReservation._onEnregistrementDocumentReservation(idReservation, idOperation, this._selection.getSelection());

            enregistrementDocumentReservation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                        this.props.onFermeFicheDocumentReservation();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            this.setState({ idReservation: 0, idOperation: 0, listDocumentsSelectionnes: [] });
        }
    }

    _chargementDonnees() {
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);

        if (idReservationRenseigneeEtDifferent && idOperationRenseigneeEtDifferent) {
            this.setState({ enCoursDeTraitement: true, messageEnCoursTraitement: "Chargement des documents" });

            var chargementDocumentReservation = DataDocumentReservation._chargementDocumentReservation(this.props.idReservation, this.props.idOperation);

            chargementDocumentReservation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        let stateTemp = {};
                        stateTemp.idReservation = this.props.idReservation;
                        stateTemp.idOperation = this.props.idOperation;
                        stateTemp.documents = objetData;
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
        else {
            this.setState({
                idReservation: 0,
                idOperation: 0,
                documents: []
            });
        }
    }

    _onRenderFooterContent = () => {
        return (
            <div>
                <PrimaryButton onClick={() => this._onEnregistrement()} disabled={!this._selection.getSelectedCount() > 0} style={{ marginRight: '8px' }}>Valider</PrimaryButton>
                <DefaultButton onClick={() => this._onAnnulation()}>Fermer</DefaultButton>
            </div>
        );
    };

    _onOpen = () => {
        this._chargementDonnees();
    }

    componentDidMount() {
        //this._chargementDonnees();
    }

    componentWillUnmount() {
    }

    componentDidUpdate() {
        //if (((this.props.idReservation !== undefined && this.props.idReservation !== this.state.idReservation)
        //    && (this.props.idOperation !== 0 && this.props.idOperation !== this.state.idOperation))
        //    && !this.state.enCoursDeTraitement) {
        //    this._chargementDonnees();
        //}
    }

    render() {
        return this._creationContent();
    }
}
